module.exports = __webpack_public_path__ + "img/rakuten.25fedbc9.png";